/* unplugin-vue-components disabled */import { render } from "./ShareWechat.vue?vue&type=template&id=5c4827e8"
import script from "./ShareWechat.vue?vue&type=script&lang=js"
export * from "./ShareWechat.vue?vue&type=script&lang=js"

import "./ShareWechat.vue?vue&type=style&index=0&id=5c4827e8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__